import { ShowMenuMovil } from './_menu.js';
import { QuitSession, ToggleShowwPass, fillFormDates, LoadAvailableNumbers, ValidateSendDates, deleteUser, deleteDriver, deleteEnrollment, deleteNews, deleteRace, deleteRound, deleteResult, initNewsForms, initResultTotalCalculator } from './_form.js';

window.fillFormDates        = fillFormDates;
window.LoadAvailableNumbers = LoadAvailableNumbers;
window.deleteUser           = deleteUser;
window.deleteDriver         = deleteDriver;
window.deleteEnrollment     = deleteEnrollment;
window.deleteNews           = deleteNews;
window.deleteRace           = deleteRace;
window.deleteRound          = deleteRound;
window.deleteResult         = deleteResult;

document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('Navicon')?.addEventListener('click', ShowMenuMovil);

    document.querySelectorAll('.admin-menu__quit, .js-quit-session').forEach(el => {
        el.addEventListener('click', QuitSession);
    });

    document.querySelectorAll('.form-field__toggle[data-target]').forEach(btn => {
        btn.addEventListener('click', event => ToggleShowwPass(event, btn.dataset.target));
    });

    document.querySelectorAll('form[data-prefix]').forEach(form => {
        form.addEventListener('submit', event => {
            ValidateSendDates(event, form.id, form.dataset.prefix, form.dataset.action || '');
        });
    });

    document.querySelectorAll('.js-btn-back').forEach(btn => {
        btn.addEventListener('click', () => history.back());
    });

    initNewsForms();
    initResultTotalCalculator();
});
